import * as types from '../mutations-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  get_target_role: {}, // 获取角色设置
  get_align_target: {}, // 选择对齐目标
  get_create_target: {}, // 创建新增目标
  get_mx_cy_target: {}, // 完成明细，成员
  get_gw_my_target_screen: {}, // 岗位目标和我的目标筛选
  get_okr_kr_weight: {}, // 目标或者kr的权重
  target_update_list: {} // 更新列表
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.TARGET_SET_ROLE](state, data) {
    state.get_target_role = data
  },
  [types.TARGET_SET_ALIGN](state, data) {
    state.get_align_target = data
  },
  [types.TARGET_SET_CREATE](state, data) {
    state.get_create_target = data
  },
  [types.TARGET_MX_CY](state, data) {
    state.get_mx_cy_target = data
  },
  [types.TARGET_GW_MY_SCREEN](state, data) {
    state.get_gw_my_target_screen = data
  },
  [types.TARGET_OKR_KR_WEIGHT](state, data) {
    state.get_okr_kr_weight = data
  },
  [types.TARGET_UPDATE_LIST](state, data) {
    state.target_update_list = data
  }
}
// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}
